//项目转合同弹窗
<template>
  <div class="dialog-body">
    <el-dialog title="关联合同" :visible.sync="dialogVisible" append-to-body width="90%" center>
      <div class="formClass">
        <el-row :gutter="24">
          <el-form
            :model="query"
            :rules="rules"
            ref="dialogForm"
            label-width="100px"
            style="margin-top: 20px"
          >
            <el-col :span="5">
              <el-form-item label="合同类型">
                <el-select v-model="query.contractCategory">
                  <el-option label="租赁合同" value="01"></el-option>
                  <el-option label="物业合同" value="02"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="5">
              <el-form-item label="合同编号">
                <el-input v-model="query.contractNo"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="5">
              <el-form-item label="客户名称">
                <el-input v-model="query.customerName"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="5">
              <el-form-item label="签约方">
                <el-input v-model="query.signPartyName"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="4">
              <el-button @click="searchClick" size="small" type="primary" class="vxe-btn-primary"
                >搜索</el-button
              >
              <el-button @click="resetBtnClick" size="small" type="primary" class="vxe-btn-primary"
                >重置</el-button
              >
            </el-col>
          </el-form>
        </el-row>
        <sirui-table
          v-if="showTable"
          ref="siruiTable"
          :data="tableData"
          :paging="true"
          height="400"
          rowKey="contractCode"
          @handleSelectionChange="handleSelectionChange"
          @handleSizeChange="handleSizeChange"
          @handleCurrentChange="handleCurrentChange"
          :auto-resize="true"
          :sync-resize="tableData"
          :setting="false"
          :customVisible="false"
          resizable
        >
          <vxe-table-column
            type="radio"
            :title="$t('search.radio')"
            width="50"
            fixed="left"
          ></vxe-table-column>
          <vxe-table-column
            v-for="(item, index) in columnList"
            :key="index"
            :fixed="item.fixed"
            :width="item.width"
            :field="item.prop"
            :title="item.label"
          >
            <template v-slot="{ row }">
              <span v-if="item.prop == 'leaseDuration'"> {{ concatDurationString(row) }}</span>
              <span v-else>{{ row[item.prop] }}</span>
            </template>
          </vxe-table-column>
        </sirui-table>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose">{{ $t('cooperation.buttons.cancel') }}</el-button>
        <el-button type="primary" @click="handleSure">确认关联</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import MerchantOverviewMixin from '@/pages/property/merchants/merchantCenter/overview/MerchantOverviewMixin';

  export default {
    name: 'MerchantRelateContractDialog',
    mixins: [MerchantOverviewMixin],

    data() {
      return {
        dialogVisible: false,
        tableData: [],
        selectedItems: [],
        nicheItem: {},
        showTable: false,
        query: {
          contractNo: null,
          customerName: null,
          signPartyName: null,
        },
        rules: {},
        columnList: [
          {
            prop: 'contractNo',
            label: '合同编号',
            width: 100,
          },
          {
            prop: 'contractName',
            label: '合同名称',
            width: 140,
          },
          {
            prop: 'customerName',
            label: '客户名称',
            width: 100,
          },
          {
            prop: 'signPartyName',
            label: '签约方',
            width: 100,
          },
          {
            prop: 'leaseDuration',
            label: '租赁期限',
            width: 250,
          },
          {
            prop: 'auditStatusName',
            label: '审核状态',
            width: 100,
          },
          {
            prop: 'contractStatusName',
            label: '合同状态',
            width: 100,
          },
          {
            prop: 'createPersonName',
            label: '创建人',
            width: 100,
          },
          {
            prop: 'gmtCreate',
            label: '创建时间',
            width: 100,
          },
        ],
      };
    },
    watch: {
      dialogVisible(value) {
        if (value) {
          this.showTable = value;
        }
      },
    },
    methods: {
      concatDurationString(row) {
        let start = row['leaseDateFrom'];
        let end = row['leaseDateUntil'];
        return start + '-' + end;
      },
      async openDialog(item) {
        this.dialogVisible = true;
        for (let key in this.query) {
          this.query[key] = null;
        }
        if (item) {
          this.nicheItem = { ...item };
          this.searchTrigger();
        }
      },
      resetBtnClick() {
        console.log('resetBtnClick');
        this.$refs.siruiTable.setPageNum(1);
        this.$refs.siruiTable.setPageSize(10);
        this.$refs.siruiTable.clearCheckboxRow();
        for (let key in this.query) {
          this.query[key] = null;
        }
        this.searchTrigger();
      },
      searchClick() {
        this.$refs.siruiTable.clearCheckboxRow();
        this.$refs.siruiTable.setPageNum(1);
        this.searchTrigger();
      },
      searchTrigger() {
        this.$nextTick(async () => {
          // this.loading.startLoading();
          const { pageNum, pageSize } = this.$refs.siruiTable.page;
          let params = { ...this.query, pageNum, pageSize };
          await this.getContractList(params);
          // this.loading.endLoading();
        });
      },
      handleSizeChange() {
        const { pageNum, pageSize } = this.$refs.siruiTable.page;
        let params = { ...this.query, pageNum, pageSize };
        this.getContractList(params);
      },
      //第几页
      handleCurrentChange() {
        const { pageNum, pageSize } = this.$refs.siruiTable.page;
        let params = { ...this.query, pageNum, pageSize };
        this.getContractList(params);
      },
      handleSelectionChange(row) {
        this.selectedItems = row;
      },
      handleClose() {
        this.$refs.siruiTable.clearCheckboxRow();
        this.tableData = [];
        this.nicheItem = {};
        for (let key in this.query) {
          this.query[key] = null;
        }
        this.dialogVisible = false;
      },
      async handleSure() {
        let empty = !this.selectedItems || !this.selectedItems.length;
        let justOne = this.selectedItems.length == 1;
        let item = this.selectedItems[0];

        if (empty) {
          this.$message.error('请选择数据！');
          return;
        }
        if (!justOne) {
          this.$message.error('请选择一条数据！');
          return;
        }

        let nicheCustomerCode = this.nicheItem.customerCode;
        let contractCustomerCode = item.customerCode;

        let _self = this;

        async function submit() {
          let params = { id: _self.nicheItem.id, relatedContractNo: item.contractNo };
          //fixme
          let res = await _self.submitRelateContract(params);
          if (res == 'success') {
            _self.$emit('handleSure');
            _self.handleClose();
          }
        }
        if (nicheCustomerCode != contractCustomerCode) {
          this.dialogVisible = false;
          this.$confirmAction(
            '关联合同',
            '招商客户名称与合同签约客户名称不一致，确认要关联吗',
            '确认',
            '取消'
          )
            .then(() => {
              this.dialogVisible = true;

              submit();
            })
            .catch(() => {
              this.dialogVisible = true;
              this.$message({
                showClose: true,
                type: 'info',
                message: '已取消',
              });
            });
          return;
        }
        submit();
      },
    },
  };
</script>

<style scoped>
  ::v-deep .el-dialog__footer {
    text-align: center;
  }

  .el-dialog .el-dialog__body {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .dialog-body {
    display: flex;
    justify-content: center;
    flex-direction: column;
  }

  .formClass {
    padding: 20px 50px 20px 50px;
  }

  ::v-deep .el-dialog-footer {
    text-align: center;
  }
</style>
